import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/match_setting_icon.png'
import _imports_1 from '@/assets/images/play_off_btn.png'


const _withScopeId = n => (_pushScopeId("data-v-2118db31"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg wraplist",
  style: {"padding-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_2 = {
  key: 0,
  class: "topDownloadBox"
}
const _hoisted_3 = { class: "topDownload-keep-px" }
const _hoisted_4 = { class: "leftcon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "titleCon" }
const _hoisted_7 = { style: {"font-size":"13px","font-weight":"blod"} }
const _hoisted_8 = { style: {"font-size":"9px"} }
const _hoisted_9 = { class: "rightcon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"10px"} }, null, -1 /* HOISTED */))
const _hoisted_12 = { class: "nav-right" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.showDownApp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", { src: $setup.downLogo }, null, 8 /* PROPS */, _hoisted_5),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('tips.qwzk')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('tips.lgtp')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "btn",
                  style: _normalizeStyle({ backgroundColor: $setup.activeColor, color: $setup.activeFontColor }),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toDownloadApp()))
                }, _toDisplayString(_ctx.$t('tips.downloadApp')), 5 /* TEXT, STYLE */),
                _createElementVNode("img", {
                  class: "close",
                  src: $setup.close_icon,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showDownApp = false))
                }, null, 8 /* PROPS */, _hoisted_10)
              ])
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_van_tabs, {
        sticky: "",
        style: _normalizeStyle({ top: $setup.showDownApp ? '70px' : '0px' }),
        "offset-top": $setup.showDownApp ? 70 : 0,
        active: $setup.state,
        "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (($setup.state) = $event)),
        "before-change": $setup.tabchange,
        "line-width": "15px",
        "line-height": "3px",
        ellipsis: false,
        color: $setup.primaryColor,
        background: "#F8F8F8",
        "title-active-color": "#303030",
        "title-inactive-color": "#898989",
        class: "tabs"
      }, {
        "nav-right": _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: _normalizeClass($setup.isRefesh ? 'animation' : ''),
              src: _imports_0,
              onClick: $setup.matchSettingClick
            }, null, 2 /* CLASS */)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_van_tab, {
            title: _ctx.$t('home.onFocus'),
            name: "0"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MatchTabs"], {
                nav_type: 4,
                offset_top: $setup.showDownApp ? 114 : 44
              }, null, 8 /* PROPS */, ["offset_top"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createVNode(_component_van_tab, {
            title: $setup.t('home.zhongyao'),
            name: "1"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MatchTabs"], {
                nav_type: 5,
                offset_top: $setup.showDownApp ? 114 : 44
              }, null, 8 /* PROPS */, ["offset_top"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createVNode(_component_van_tab, {
            title: $setup.t('home.remen'),
            name: "2"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MatchTabs"], {
                nav_type: 0,
                offset_top: $setup.showDownApp ? 114 : 44
              }, null, 8 /* PROPS */, ["offset_top"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createVNode(_component_van_tab, {
            title: $setup.t('home.Tab_1'),
            name: "3"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MatchTabs"], {
                nav_type: 1,
                offset_top: $setup.showDownApp ? 114 : 44
              }, null, 8 /* PROPS */, ["offset_top"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createVNode(_component_van_tab, {
            title: $setup.t('home.Tab_2'),
            name: "4"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MatchTabs"], {
                nav_type: 2,
                offset_top: $setup.showDownApp ? 114 : 44
              }, null, 8 /* PROPS */, ["offset_top"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createVNode(_component_van_tab, {
            title: $setup.t('home.saiguo'),
            name: "5"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["MatchTabs"], {
                nav_type: 3,
                offset_top: $setup.showDownApp ? 114 : 44
              }, null, 8 /* PROPS */, ["offset_top"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["style", "offset-top", "active", "color"])
    ]),
    _createCommentVNode(" <transition name=\"slide-fade\" mode=\"out-in\" v-if=\"th != 'th'\">\r\n    <div class=\"rightBottomBox\" v-show=\"showAnimation\" style=\"margin-bottom: env(safe-area-inset-bottom);\">\r\n      <img @click=\"nativeToNewWeb(router,'/activity?a=1')\" :src=\"pos1\" alt=\"\">\r\n      <img @click=\"nativeToNewWeb(router,'/invitef?a=1')\" :src=\"pos2\" alt=\"\">\r\n    </div>\r\n  </transition> "),
    _withDirectives(_createElementVNode("div", {
      class: "rightBottomBox",
      style: _normalizeStyle({ bottom: $setup.Platform.client == 'ios' ? '80px' : '120px' })
    }, [
      _createCommentVNode(" <img class=\"downBox2\" @click=\"nativeToNewWeb(router, '/activity?a=1')\" :src=\"pos1\"\r\n    v-drag\r\n    :style=\"{ left: screen.width-53 + 'px', top: screen.height-375 + 'px',position: 'fixed' }\"\r\n    alt=\"\">\r\n    <img class=\"downBox2\" @click=\"nativeToNewWeb(router, '/invitef?a=1')\" :src=\"pos2\"\r\n    v-drag\r\n    :style=\"{ left: screen.width-53 + 'px', top: screen.height-310 + 'px',position: 'fixed' }\"\r\n    alt=\"\"> ")
    ], 4 /* STYLE */), [
      [_vShow, $setup.is_has_history]
    ]),
    ($setup.matchAD && $setup.showAd)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "adbox",
          style: _normalizeStyle({ bottom: $setup.Platform.client == 'h5' ? '57px' : '10px', marginBottom: 'env(safe-area-inset-bottom)' })
        }, [
          _createElementVNode("img", {
            class: "adimg",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toLocationBrowser($setup.matchAD.url))),
            src: $setup.matchAD.img,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_13),
          _createElementVNode("img", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showAd = false)),
            class: "offbtn",
            src: _imports_1,
            alt: ""
          })
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_van_overlay, {
      show: $setup.alertDown,
      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.alertDown = false)),
      "z-index": "99999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("img", {
            class: "bg",
            src: $setup.arterBg,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_14),
          _createElementVNode("img", {
            class: "btn",
            src: $setup.arterBtn,
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.open())),
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_15),
          _createElementVNode("img", {
            class: "offbtn",
            src: $setup.offArterBtn,
            alt: "",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.alertDown = false))
          }, null, 8 /* PROPS */, _hoisted_16)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}